import React from 'react'
import CreateReactApp from '../containers/CreateReactApp'
import {useDispatch} from "react-redux";
import changes from "../redux/changesDuck";
import {innerResult} from "../redux/changesEpic";

function Landing(){
            const dispatch = useDispatch();
    // innerResult()
    dispatch(changes.actions.fetchChangesLayersRequest())

    return (
        <CreateReactApp/>
    )

}


export default Landing



// WEBPACK FOOTER //
// ./src/routes/Landing.js